"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_INSURANCE_PERMISSIONS = exports.InsurancePermissions = void 0;
/**
 * Insurance module permission catalog — ADR-098 Phases 3 and 4.
 *
 * FIVE permissions, and each exists because one person must not be able to do
 * two things:
 *
 *   - `insurance:policy:verify` — confirming a patient's policy with the insurer.
 *     Held separately from filing the policy (`patient:coverage:manage`) so the
 *     person who types a policy number in is not the person who vouches for it.
 *     Until Phase 3 verification rode on the filing permission, which meant a
 *     clerk could enter a policy and mark it verified in the same minute.
 *
 *   - `insurance:document:manage` — attaching a document to a pre-authorisation
 *     or a claim, and removing one.
 *
 *   - `insurance:document:view` — reading or downloading one. Separate from
 *     `manage` because these are patient medical records (discharge summaries,
 *     investigation reports): a person who prepares a claim's paperwork and a
 *     person who only chases payment do not need the same access.
 *
 *   - `insurance:remittance:post` — recording an insurer's payment. It moves money in
 *     the ledger (bank, TDS receivable, insurance receivable), so it is not the same
 *     right as raising or deciding a claim, and reversing a mistaken one needs it too.
 *
 *   - `insurance:writeoff:approve` — approving that the hospital absorbs an amount the
 *     insurer will not pay. Maker-checker: the person who requested the write-off can
 *     never approve it, whatever they hold; this permission only says who MAY.
 *
 * The rest of the module reuses the ADR-085 `ip:insurance:*` permissions, which
 * are already seeded and granted. THE COUNT STAYS SMALL ON PURPOSE: the JWT
 * embeds every permission a user holds and this platform has already hit the
 * Node and nginx header ceilings once.
 *
 * Registering this family takes TWO edits — `seedInsuranceCatalog()` on
 * `PermissionService` and its name in `scripts/deploy-seed-all-catalogs.ts`.
 * Doing only the first leaves every route gated on these keys answering 403 to
 * everyone, SuperAdmin included.
 */
exports.InsurancePermissions = {
    INSURANCE_POLICY_VERIFY: 'insurance:policy:verify',
    INSURANCE_DOCUMENT_MANAGE: 'insurance:document:manage',
    INSURANCE_DOCUMENT_VIEW: 'insurance:document:view',
    INSURANCE_REMITTANCE_POST: 'insurance:remittance:post',
    INSURANCE_WRITEOFF_APPROVE: 'insurance:writeoff:approve',
};
exports.ALL_INSURANCE_PERMISSIONS = Object.values(exports.InsurancePermissions);
//# sourceMappingURL=insurance.permissions.js.map